export const investmentSlr = (state) => state.dashboard.investmentState;
export const portfolioSlr = (state) => state.dashboard.portfolioState;
export const transactionSlr = (state) => state.dashboard.transactionState;
export const newsSlr = (state) => state.dashboard.newsState;